import {
  Typenames,
  UserAvatarAssetResultTypenames,
} from '@varo/graphql-schema-types';
import ActivatedOfferCard from 'features/rewards/components/ActivatedOfferCard/ActivatedOffer';
import { useMyOffersContext } from 'features/rewards/screens/MyOffers/providers/MyOffersProvider';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { TagType } from 'shared/components/vxl/Tag/Tag';
import TitleSmText from 'shared/components/vxl/typography/primary/title/TitleSmText';
import theme from 'shared/styles/theme';

const SelfFundedOffersList = () => {
  const {
    selfFundedItems: items,
    selfFundedSectionTitle: sectionTitle,
    onOfferClick,
  } = useMyOffersContext();
  return (
    <View style={styles.selfFundedSection} testID="self-funded-section">
      {sectionTitle ? (
        <View style={styles.sectionTitleContainer}>
          <TitleSmText>{sectionTitle}</TitleSmText>
        </View>
      ) : null}
      {items.map((item) =>
        (item.offers ?? []).map((offer, index) => {
          const avatarUrl =
            offer.leadingAccessory?.__typename === Typenames.UserAvatar &&
            offer.leadingAccessory.userAvatarAsset?.__typename ===
              UserAvatarAssetResultTypenames.URLType
              ? offer.leadingAccessory.userAvatarAsset?.url
              : '';

          const offerId =
            'id' in offer && typeof offer.id === 'string'
              ? offer.id
              : `self-funded-${offer.primaryText}-${index}`;

          return (
            <View key={offerId} style={styles.activatedOfferCardContainer}>
              <View style={styles.cardWrapper}>
                <ActivatedOfferCard
                  offerId={offerId}
                  avatarUrl={avatarUrl ?? ''}
                  title={{ text: offer.primaryText }}
                  subTitle={{ text: offer.secondaryText ?? '' }}
                  tag={
                    offer.trailingAccessory?.__typename === Typenames.Tag
                      ? {
                          text: offer.trailingAccessory.text,
                          type: TagType.INFO_REVERSE,
                          iconKey: offer.trailingAccessory.icon,
                        }
                      : undefined
                  }
                  onClick={() => onOfferClick(offer)}
                />
              </View>
            </View>
          );
        }),
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  selfFundedSection: {
    marginBottom: theme.spacing.s,
  },
  sectionTitleContainer: {
    paddingHorizontal: theme.spacing.m,
    marginBottom: theme.spacing.s,
  },
  activatedOfferCardContainer: {
    marginHorizontal: theme.spacing.m,
    marginBottom: 0,
  },
  cardWrapper: {
    marginHorizontal: -theme.spacing.m,
  },
});

export default SelfFundedOffersList;
